@import "/src/styles/mixins.sass"

.container
    height: 100%
    overflow-x: hidden
    display: grid
    grid-template-columns: 17rem 1fr
    grid-template-rows: 1fr

    @include mappy-bp(max laptop)
        grid-template-columns: 4.5rem 1fr

        .menuBackground
            position: relative
            z-index: 50
            grid-area: 1 / 1 / 2 / 3
            pointer-events: none
            transition: background-color 0.2s ease

        .menuOpened + .menuBackground
            pointer-events: all
            background-color: rgba(0,0,0,0.65)

    .snackbars
        position: relative
        z-index: 40
        grid-area: 1 / 2 / 2 / 3
        pointer-events: none
        display: flex
        flex-direction: column
        justify-content: flex-end
        align-items: center
        gap: 1rem
        padding-bottom: 1rem

        .snackbar
            pointer-events: all

            @include mappy-bp(max tablet)
                margin: 0 1rem

            @include mappy-bp(tablet desktop)
                max-width: 65vw

            @include mappy-bp(desktop)
                max-width: 40vw

    main
        grid-area: 1 / 2 / 2 / 3
        padding: 4rem
        overflow-y: auto
        display: flex
        flex-direction: column

        @include mappy-bp(max laptop)
            padding: 2rem

        h1
            @include header

        h1
            margin-bottom: 2rem

            span
                margin-left: 1rem
                color: var(--color-black-primary-disabled)

                &:before
                    content: "#"

    nav
        grid-area: 1 / 1 / 2 / 2
        padding: 2rem 0
        background-color: var(--color-white-primary)
        box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25)
        display: flex
        flex-direction: column
        gap: 2rem
        overflow: hidden auto

        @include mappy-bp(tablet laptop)
            a:hover, button:hover
                background-color: var(--color-grey-light)

        @include mappy-bp(max laptop)
            grid-area: 1 / 1 / 2 / 3
            position: relative
            z-index: 100
            transition: width 0.2s ease-in-out

            &:not(.menuOpened)
                width: 4.5rem

                .bottom
                    opacity: 0

            &.menuOpened
                width: 17rem

                .menuButtonOpen svg
                    transform: rotateY(180deg)

                .bottom
                    opacity: 1

                svg
                    margin: 0 1rem

            .menuButtonOpen svg
                transition: transform 0.2s ease-in-out, margin 0.2s ease

            .bottom
                transition: opacity 0.2s ease

            svg
                transition: margin 0.2s ease

            h3
                display: none

            a, button
                @include tappable

        @include mappy-bp(laptop)
            .menuButtonOpen
                display: none

            svg
                margin: 0 1rem

            a:hover, button:hover
                text-indent: 0.2rem

        .top, .middle, .bottom
            flex: 1
            display: flex
            flex-direction: column

        .top
            justify-content: flex-start

        .middle
            justify-content: center

        .bottom
            justify-content: flex-end

        h3
            @include input
            text-align: center

        a, button
            align-items: flex-start
            padding: 1rem

            span
                @include label-large
                line-height: 1.5
                gap: 1rem
                transition: text-indent 200ms ease
